export interface ProfileImageState {
  path: string;
  loading: boolean;
  error: string;
}

export const initialProfileImageState: ProfileImageState = {
  path: '',
  loading: false,
  error: ''
};
